var path = '/_common/directives/ifastDropDownList/ifastDropDownList.tpl.html';
var html = "<label class=label-hidden for=ifastDDL{{$id}}>Dropdown List</label> <select kendo-drop-down-list=dropDownObject k-options=iFastDropDownListController.options k-on-change=onChange()(kendoEvent) k-on-select=onSelect()(kendoEvent) k-on-cascade=onCascade()(kendoEvent) k-on-data-bound=\"iFastDropDownListController.onDataBound(iFastDropDownListController, kendoEvent)\" k-ng-model=selectedItem title={{iFastDropDownListController.dropdownTitle}} id=ifastDDL{{$id}} />";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/_common/directives/ifastDropDownList/ifastDropDownList.tpl.html
// module id = 773
// module chunks = 0 2